export default __webpack_public_path__ + "img/98e5497e385abeff7cf3ff0c2c9d1960.png";